// extracted by mini-css-extract-plugin
export default {"wrapper":"basic-card__wrapper","content":"basic-card__content","footer":"basic-card__footer"};